import React from "react";

const LeadColumn = (props) => {
    const {leadinfo} = props;
    const {leadstotal} = props;
    return(
        <div className="column">
        <div className="block-title bg-2">Leads</div>
        <ul>
            <li>
                <span className="data-value">{leadstotal}</span>
                <span className="data-label">Created</span>
            </li>
            <li className="p-0">
                <ul>
                    <li>
                        <span className="data-value">{leadinfo?.open?.count}</span>
                        <span className="data-label">Open</span>
                    </li>
                    <li>
                        <span className="data-value">{leadinfo?.won?.count}</span>
                        <span className="data-label">Won</span>
                    </li>
                    <li>
                        <span className="data-value">{leadinfo?.lost?.count}</span>
                        <span className="data-label">Lost</span>
                    </li>
                    <li>
                        <span className="data-value">{leadinfo?.ignore?.count}</span>
                        <span className="data-label">Ignored</span>
                    </li>
                    <li>&nbsp;</li>
                    
                </ul>
            </li>
        </ul>
    </div>
    );
}

export default LeadColumn;